import "./layout.css";
import React, { Component } from 'react';
import { Col, Grid, Row } from 'react-bootstrap';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import Navigation from '../navigation/navigation.jsx';
import Header from '../header/header.jsx';
import Position from '../position/position.jsx';
import FundPosition from '../position/fundPosition.jsx';
import Summary from '../summary/summary.jsx';
import Analytics from '../analytics/analytics.jsx';
import Reports from '../reports/reports.jsx';
import UserInfo from '../userInfo/userInfo.jsx';
import Users from '../users/users.jsx';
import ClientDetail from '../users/clientDetail.jsx';
import Settings from '../settings/settings.jsx';
import Data from '../data/data.jsx';
import AnalyticsManagement from '../analyticsManagement/analyticsManagement.jsx';
import ReportsManagement from '../reportsManagement/reportsManagement.jsx';
import Accordion from 'devextreme-react/accordion';

import service from './disclaimer-data.jsx';
import CustomTitle from './customTitle.jsx';
import CustomItem from './customItem.jsx';
import BannerSwitch from "../banner/bannerSwitch.jsx";


export default class Layout extends React.Component {
    
    constructor(props) {
        super(props);

        this.disclaimer = service.getDisclaimer();        
        
        //this.onContentReady = this.onContentReady.bind(this);
    }

    //onContentReady(e) {
    //    e.component.collapseItem(0);
    //}

    render() {    

        const collapsible = false;
        const multiple = false;
        const animationDuration = 300;

        return (
            <div id="page-container">
                <div id="content-wrap">
                    <Grid fluid>
                        <Row>
                            <Col>
                                <Header />
                            </Col>
                        </Row>
                        <Row>
                            <Col lg={2} md={3}>
                                <Navigation />
                            </Col>
                            <Col lg={10} md={9}>
                                <Switch>
                                    <Route path="/users/clientDetails" component={ClientDetail} />
                                    <Route path="/users" component={Users} />
                                    <Route path="/settings" component={Settings} />
                                    <Route path="/userInfo" component={UserInfo} />
                                    <Route path="/reports" component={Reports} />
                                    <Route path="/reportsManagement" component={ReportsManagement} />
                                    <Route path="/analytics" component={Analytics} />
                                    <Route path="/analyticsManagement" component={AnalyticsManagement} />
                                    <Route path="/summary" component={Summary} />
                                    <Route path="/position" component={Position} />
                                    <Route path="/fundPosition" component={FundPosition} />
                                    <Route path="/data" component={Data} />
                                    <Route path="/bannerSwitch" component={BannerSwitch} />
                                </Switch>
                            </Col>
                        </Row>
                    </Grid>  
                    <div className="disclaimer">
                        <Accordion
                            dataSource={this.disclaimer}
                            collapsible={collapsible}
                            multiple={multiple}
                            animationDuration={animationDuration}
                            itemRender={CustomItem}
                            onContentReady={this.onContentReady}
                        />
                    </div>
                </div>
            </div>

        );
    }
}


// WEBPACK FOOTER //
// ./App/containers/layout/layout.jsx